import React, { useState } from 'react';

const Pricing = () => {
    // Estado para controlar a visibilidade do modal
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedPlan, setSelectedPlan] = useState('');

    // Função para abrir o modal e definir o plano escolhido
    const openModal = (planName) => {
        setSelectedPlan(planName);
        setIsModalOpen(true);
    };

    // Função para fechar o modal
    const closeModal = () => {
        setIsModalOpen(false);
    };

    // Função para direcionar ao WhatsApp
    const redirectToWhatsapp = () => {
        const message = `Olá, gostaria de assinar o plano ${selectedPlan}.`;
        const whatsappUrl = `https://wa.me/5585982007804?text=${encodeURIComponent(message)}`;
        window.open(whatsappUrl, '_blank');
    };

    return (
        <div className="w-full bg-gradient-to-b from-purple-100 via-purple-200 to-white py-12 mt-12">
            <h2 className="text-center text-4xl font-bold text-purple-600 mb-8">Planos e Preços</h2>
            <div className="grid md:grid-cols-3 gap-8 px-8">
                {/* Plano Básico */}
                <div className="bg-white shadow-xl p-8 rounded-2xl flex flex-col h-full transform transition-transform duration-300 hover:scale-105">
                    <h3 className="text-2xl font-semibold text-purple-700">Plano Básico</h3>
                    <p className="text-lg font-semibold text-purple-900">R$ 321,94/mês</p>
                    <p className="text-sm text-gray-600"><strong>R$ 3.476,95 por ano</strong> (desconto de 10%)</p>
                    <ul className="mt-6 text-gray-700">
                        <li>✅ Até 500 leads por mês</li>
                        <li>✅ Suporte via e-mail</li>
                        <li>✅ Relatórios básicos</li>
                        <li>✅ Automação de mensagens simples</li>
                        <li>✅ Acesso ao WhatsApp básico</li>
                        <li>✅ Treinamento online</li>
                    </ul>
                    <div className="mt-auto">
                        <button
                            className="bg-gradient-to-r from-green-400 to-green-600 hover:from-green-600 hover:to-green-400 text-white py-3 px-6 rounded-lg w-full transition-transform duration-300 transform hover:scale-105"
                            onClick={() => openModal('Básico')}
                        >
                            Assinar
                        </button>
                    </div>
                </div>

                {/* Plano Avançado */}
                <div className="bg-white shadow-xl p-8 rounded-2xl flex flex-col h-full transform transition-transform duration-300 hover:scale-105">
                    <h3 className="text-2xl font-semibold text-purple-700">Plano Avançado</h3>
                    <p className="text-lg font-semibold text-purple-900">R$ 674,94/mês</p>
                    <p className="text-sm text-gray-600"><strong>R$ 6.884,39 por ano</strong> (desconto de 15%)</p>
                    <ul className="mt-6 text-gray-700">
                        <li>✅ Até 3000 leads por mês</li>
                        <li>✅ Suporte via WhatsApp em horário comercial</li>
                        <li>✅ Relatórios avançados com gráficos</li>
                        <li>✅ Automação de mensagens personalizadas</li>
                        <li>✅ Integração com CRM</li>
                        <li>✅ Prioridade no suporte</li>
                        <li>✅ Treinamento online</li>
                    </ul>
                    <div className="mt-auto">
                        <button
                            className="bg-gradient-to-r from-green-400 to-green-600 hover:from-green-600 hover:to-green-400 text-white py-3 px-6 rounded-lg w-full transition-transform duration-300 transform hover:scale-105"
                            onClick={() => openModal('Avançado')}
                        >
                            Assinar
                        </button>
                    </div>
                </div>

                {/* Plano Empresarial */}
                <div className="bg-white shadow-xl p-8 rounded-2xl flex flex-col h-full transform transition-transform duration-300 hover:scale-105">
                    <h3 className="text-2xl font-semibold text-purple-700">Plano Empresarial</h3>
                    <p className="text-lg font-semibold text-purple-900">R$ 1.482,94/mês</p>
                    <p className="text-sm text-gray-600"><strong>R$ 14.076,22 por ano</strong> (desconto de 20%)</p>
                    <ul className="mt-6 text-gray-700">
                        <li>✅ Até 7500 leads por mês</li>
                        <li>✅ Suporte via WhatsApp dentro e fora do horário comercial</li>
                        <li>✅ Suporte via acesso remoto</li>
                        <li>✅ Relatórios avançados com gráficos</li>
                        <li>✅ Automação de mensagens personalizadas</li>
                        <li>✅ Automação com IA</li>
                        <li>✅ Integração com CRM</li>
                        <li>✅ Prioridade no suporte</li>
                        <li>✅ Treinamento online exclusivo para equipes</li>
                        <li>✅ Acesso beta a funcionalidades</li>
                    </ul>
                    <div className="mt-auto">
                        <button
                            className="bg-gradient-to-r from-green-400 to-green-600 hover:from-green-600 hover:to-green-400 text-white py-3 px-6 rounded-lg w-full transition-transform duration-300 transform hover:scale-105"
                            onClick={() => openModal('Empresarial')}
                        >
                            Assinar
                        </button>
                    </div>
                </div>
            </div>

            {/* Modal */}
            {isModalOpen && (
                <div className="fixed inset-0 flex items-center justify-center bg-gray-700 bg-opacity-50 z-50">
                    <div className="bg-white p-8 rounded-lg shadow-lg w-96 text-center">
                        <h3 className="text-2xl font-semibold mb-4">Você escolheu o Plano {selectedPlan}</h3>
                        <p>Confirme sua escolha e vamos direcioná-lo para o WhatsApp para concluir a assinatura.</p>
                        <div className="mt-6">
                            <button
                                className="bg-green-600 hover:bg-green-700 text-white py-3 px-6 rounded-lg mt-4 w-full"
                                onClick={redirectToWhatsapp}
                            >
                                Enviar para o WhatsApp
                            </button>
                            <button
                                className="mt-4 text-gray-600 hover:text-gray-800 w-full"
                                onClick={closeModal}
                            >
                                Fechar
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Pricing;
